import { appStoreLink, playStoreLink } from "../../utils/appLinks";
import classes from "./Styles/Section1styles.module.css";

const Section1 = () => {
  return (
    <section className={classes.section}>
      <div className={classes.details}>
        <div className={classes.name}>
          <h1>
            Welcome <br /> to the Sprinterwave
          </h1>
        </div>

        <div className={classes.stack}>
          <p>
            Sprinterwave makes life easier with quick rides, easy bills, and
            event bookings. Stay connected and get things done seamlessly.
            Your everyday go-to for convenience on the move.
          </p>

          <div className={classes.support}>
            <p>Support Available 24/7</p>
            <div className={classes.routeLine} />
          </div>

          <div className={classes.hide_on_desktop}>
            <DownloadBtn />
          </div>
        </div>
      </div>

      <div className={classes.details2}>
        <div className={classes.name}>
          <h1>
            Get started <br /> using Sprinterwave
          </h1>
        </div>
        <p>Download the app today to start enjoying tons of features</p>

        <DownloadBtn />
      </div>
    </section>
  );
};

const DownloadBtn = () => {
  return (
    <div className={classes.download_}>
      <a
        target="_blank"
        rel="noreferrer"
        href={playStoreLink}
      >
        <img src="/images/playstore_.webp" alt="Get it on Google Play" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href={appStoreLink}
      >
        <img src="/images/appstore_.webp" alt="Get it on App Store" />
      </a>
    </div>
  );
};

export default Section1;